<template>
  <div class="pagination" >
    <mds-pagination
      :total-items="totalElements"
      :page="paginationOptions.page"
      @mds-pagination-page-changed="handlePageChange"
      :class="{ disabledNext: dataLength < 100}"
    />
  </div>
</template>

<script>
import MdsPagination from '@mds/pagination';

export default {
  name: 'PaginationSection',
  components: {
    MdsPagination,
  },
  props: {
    dataLength: {
      type: Number,
      required: true,
      default: 0, // Default to 0 to avoid empty pagination
    } 
  },
    data() {
      return {
      // totalElements: 0, // This will be set from the store
      pageSizes: [100],
      totalElements: this.dataLength || 0, // Default to 1 to avoid empty pagination
      paginationOptions: {
        page: 1, // Default to first page
        pageSize: 100, // Default page size
      },
    };
  },
  methods: {
    handlePageChange(page) {
      this.paginationOptions.page = page.page;
      this.$emit('page-changed', page);
    },
    resetPage() {
      this.paginationOptions.page = 1;
    }
  },
  computed: {
    disableNext() {
      return this.dataLength < 100;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .mds-pagination__dap-crawler .mds-pagination__page-select__dap-crawler{
  display: none;
}
.disabledNext ::v-deep .mds-button-container__dap-crawler .mds-button__dap-crawler + .mds-button__dap-crawler {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
</style>
